import React from "react";
import { Col } from "~/components/elements";
import { PageLayout } from "~/components/layouts/PageLayout";
import { useInput } from "~/hooks";
import { ConfirmVerificationCode } from "~/pages/forgot-password/ConfirmVerificationCode";
import { InputEmail } from "~/pages/forgot-password/InputEmail";
import { ForgotPasswordStep } from "~/types/general";
import { SetNewPassword } from "~/pages/forgot-password/SetNewPassword";
import { Success } from "~/pages/forgot-password/Success";

interface InputValues {
  email: string;
  code: string;
  userId: string;
  step: ForgotPasswordStep;
}

function ForgotPassword() {
  const [inputs, setInputs] = useInput<InputValues>({
    email: "",
    code: "",
    userId: "",
    step: "input",
  });

  const renderPage = () => {
    if (inputs.step === "input") {
      return <InputEmail onSuccess={({ email, userId }) => setInputs({ email, userId, step: "verify" })} />;
    }

    if (inputs.step === "verify") {
      return (
        <ConfirmVerificationCode
          onSuccess={({ code }) => setInputs({ code, step: "confirm" })}
          userId={inputs.userId}
          email={inputs.email}
          type="resetPassword"
        />
      );
    }

    if (inputs.step === "confirm") {
      return (
        <SetNewPassword
          onSuccess={({ userId }) => setInputs({ userId, step: "success" })}
          code={inputs.code}
          userId={inputs.userId}
        />
      );
    }
    if (inputs.step === "success") {
      return <Success email={inputs.email} />;
    }
    return null;
  };

  return (
    <PageLayout
      metaTagsConfig={{
        metas: [{ name: "robots", content: "noindex,nofollow" }],
      }}
    >
      <Col alignItems="center" h="100vh" justifyContent={{ base: "flex-start", md: "center" }}>
        {renderPage()}
      </Col>
    </PageLayout>
  );
}

export default ForgotPassword;
